import React, { useState } from "react";
import ReactPlayer from "react-player";
import Style from "./home.module.css";
import defaultIMG from "../../../Assets/defaultimg.png";

const AboutUs = () => {
  const [isMuted, setIsMuted] = useState(true);

  const handleMuteToggle = () => {
    setIsMuted((prev) => !prev);
  };

  return (
    <div className={Style.home_about_container}>
      <h1 className={Style.home_about_title}>About Us</h1>
      <div className={Style.home_about_video_container}>
        <ReactPlayer
          className={Style.home_about_video_player}
          url="https://youtu.be/aLlYyYLmp-Q" 
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultIMG;
          }}
          playing={false}
          controls
          muted={isMuted}
          width="1200px"
          height="600px"
          onClick={handleMuteToggle}
          style={{ borderRadius: "40px" }}
        />
      </div>
    </div>
  );
};

export default AboutUs;


